import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import {
  FetchMSSListResponse,
  RenameFolderResponse,
  SearchInfoResponse,
} from "../../types/api-response";
import {
  ArchiveMssFolderPayload,
  RenameMssSearchPayload,
  fetchMssFolderCountPaylod,
  fetchMssFolderPaylod,
  getSearchInfoPayload,
} from "@/types/api-payload";
import { callFromMiddleware } from "@/utils/index";
import { FETCH_MSS_FOLDER } from "./tags";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});

export const manageSaveSearchApi = createApi({
  reducerPath: "manageSaveSearch",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  tagTypes: [FETCH_MSS_FOLDER],
  endpoints: (builder) => ({
    fetchMssFolders: builder.query<
      FetchMSSListResponse,
      Partial<fetchMssFolderPaylod>
    >({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.fetchMssFolders)}/${
          args.folderType
        }`,
        method: "POST",
        headers: API_HEADERS,
        body: {
          searchName: args.folderName,
          page: args.page,
        },
      }),
      providesTags: [FETCH_MSS_FOLDER],
    }),
    getSearchInfo: builder.query<
      SearchInfoResponse,
      Partial<getSearchInfoPayload>
    >({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getSearchInfo)}`,
        method: "POST",
        headers: API_HEADERS,
        body: {
          searchId: args.searchId,
          folderId: args.folderId,
          subUid: args.subUid,
          searchName: args.searchName,
          query:args.query,
          email: args.email,
          created: args.created,
          updated: args.updated,
          resAlert: args.resAlert,
          frequency: args.frequency,
          enabled: args.enabled,
          channelId: args.channelId,
        },
      }),
      providesTags: [FETCH_MSS_FOLDER],
    }),
    getMssFoldersCount: builder.query<Partial<any>, fetchMssFolderCountPaylod>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getMssFoldersCount)}?search-name=${
          args.folderName
        }`,
        method: "GET",
        headers: API_HEADERS,
      }),
      providesTags: [FETCH_MSS_FOLDER],
    }),
    renameMssFolder: builder.mutation<
      RenameFolderResponse,
      RenameMssSearchPayload
    >({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.renameMssSearch),
        method: "POST",
        headers: API_HEADERS,
        body: args,
      }),
      // refetch only on successfull api call
      invalidatesTags: (result: any, error: any) =>
        error ? [] : [FETCH_MSS_FOLDER],
    }),
    archiveMssFolder: builder.mutation<void, ArchiveMssFolderPayload>({
      query: (args: any) => ({
        url: `${callFromMiddleware(ENDPOINTS.mssFolderArchive)}/${
          args.action
        }/${args.searchId}`,
        method: "POST",
        headers: API_HEADERS,
        body: {},
      }),
      invalidatesTags: [FETCH_MSS_FOLDER],
    }),
  }),
});

export const {
  useGetSearchInfoQuery,
  useFetchMssFoldersQuery,
  useLazyFetchMssFoldersQuery,
  useGetMssFoldersCountQuery,
  useRenameMssFolderMutation,
  useArchiveMssFolderMutation,
} = manageSaveSearchApi;

export default manageSaveSearchApi;

